module.exports = __webpack_public_path__ + "img/重庆合川三江国家湿地公园@2x.ab494b16.png";